import qs from 'qs'

const linkDisputeId = qs.parse(window.location.search, {
  ignoreQueryPrefix: true
})['link_dispute_id']

export default linkDisputeId
